import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getUsers = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/users?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });
